import styled from "styled-components";
import {
  AdminContentSection,
  AdminContentSectionTitleContainer,
  Checkmark,
  OneFilterOrg,
} from "../../styled";

export const OrgDeniedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
`;

export const OrgDeniedMessage = styled.div`
  max-width: 600px;
  font-size: 1.4rem;
`;

export const UserCell = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const UserRemoveModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px 20px;
  text-align: center
  margin: -2em 0 0;
`;

export const UserRemoveModalIcon = styled.div`
  font-size: 2em;
  color: ${(p) => p.theme.color.palette.scarletRed};
  width: 2em;
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: ${(p) => p.theme.color.palette.blushRed};
`;

export {
  AdminContentSection,
  AdminContentSectionTitleContainer,
  Checkmark,
  OneFilterOrg,
};
